import { useConvertList } from "@/api/services/admin/convert-request";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { CONVERT_STATUS } from "@/constants/enum";
import { DEFAULT_PER_PAGE, START_PAGE } from "@/constants/pagination";
import { ConvertHistoryListPagination } from "@/features/convert/component/ConvertHistoryListPagination";
import { ConvertTable } from "@/features/convert/component/ConvertTable";
import { useConvertFilterCache } from "@/features/convert/provider/ConvertListFilterCacheProvider";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";

export const ConvertHistoryListPage = () => {
  const { convertFilterCache } = useConvertFilterCache();

  const { data: convertListResult, isLoading } = useConvertList({
    status: [CONVERT_STATUS.COMPLETE, CONVERT_STATUS.ERROR, CONVERT_STATUS.CANCEL],
    sorts: ["convertRequest.createdAt|DESC"],
    page: convertFilterCache?.historyPage || START_PAGE,
    perPage: DEFAULT_PER_PAGE,
  });

  if (isLoading) return <LoadingPage />;

  return (
    <>
      <TopPage title="過去の変換依頼一覧" backUrl={AppRoutes.convert} />
      <Stack gap={2}>
        <ConvertHistoryListPagination totalPage={convertListResult?.pagination.totalPage} />
        {convertListResult && <ConvertTable isLoading={isLoading} data={convertListResult ?? []} />}
      </Stack>
    </>
  );
};
